module.exports = function getResource(label, vars = []) {
    let resources = {
        seeAll: 'Voir tous les'
    };

    return resources[label];
};
